/**
 * The mode the shared user group form modal renders in:
 *  - Create → new group, no policies granted
 *  - Rename → renames the selected group, leaving its policies untouched
 *  - Duplicate → new group seeded with the source group's policies
 */
export enum UserGroupFormMode {
  Create = 'create',
  Rename = 'rename',
  Duplicate = 'duplicate',
}
